import { createAction } from '@reduxjs/toolkit';
import { nameSpace } from '../Modules/nameSpace';

const assignResponder = createAction(`${nameSpace}/assignResponder`);
const resolveEmergency = createAction(`${nameSpace}/resolve`);
const printEmergencyDetails = createAction(
  `${nameSpace}/printEmergencyDetails`,
);
const printEmergencyList = createAction(`${nameSpace}/printEmergencyList`);

export default {
  assignResponder,
  resolveEmergency,
  printEmergencyDetails,
  printEmergencyList,
};
